import { useEffect, useState } from 'react'

export interface CountdownParts {
  hours: string
  minutes: string
  seconds: string
}

function format(total: number): CountdownParts {
  const safe = Math.max(total, 0)
  const hours = Math.floor(safe / 3600)
  const minutes = Math.floor((safe % 3600) / 60)
  const seconds = safe % 60
  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  }
}

export function useCountdown(initialSeconds: number = 1800): CountdownParts {
  const [remaining, setRemaining] = useState(initialSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 0 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return format(remaining)
}
